import { Box, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import 'react-toastify/dist/ReactToastify.css';
import KenInputField from '../../../../../global_components/KenInputField';
import KenSelect from '../../../../../global_components/KenSelect/index';
import { useSnackbar } from 'notistack';
import './index.scss';

const SeatingplanInput = ({
  roomDropdown,
  facilityName,
  roomChoosen,
  onFacilityChange,
  selectedFacilityData,
  setRoomChoosen,
  setSelectedFaciltyData
}) => {
  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };
  const { enqueueSnackbar } = useSnackbar();

  // onClickClassChange
  console.log('selectedFacilityData', selectedFacilityData);
  return (
    <div>
      <Box>
        {' '}
        <Grid container>
          <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
            <div className="catergory-selectbox">
              <KenSelect
                optionalLabel={false}
                name="Facility Name"
                options={roomDropdown}
                label={'Facility Name'}
                value={facilityName}
                onChange={onFacilityChange}
                inputInputProps={{
                  select: {
                    // height: '500px',
                  },
                }}
                defaultValue={roomDropdown[0]?.value}
                style={{ fontSize: 12 }}
              />
            </div>
          </Grid>
        </Grid>
        <br/>
        <Grid container>
          <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
            <KenInputField
              optionalLabel={false}
              disabled
              label={'Capacity'}
              name="Capacity"
              // value={capacity}
              value={selectedFacilityData?.effectiveCapacity}
              // onChange={(e) => SetCapacity(parseInt(e.target.value))}
              style={{ fontSize: 12 }}
              type="Number"
            />
          </Grid>{' '}
          <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
            <KenInputField
              optionalLabel={false}
              disabled
              label={'Seat Per Bench'}
              name="seats_per_bench"
              value={selectedFacilityData?.seatsPerBench}
              // onChange={(e) => SetSeatPerBench(parseInt(e.target.value))}
              style={{ fontSize: 12 }}
              type="Number"
            />
          </Grid>{' '}
          <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
            <KenInputField
              optionalLabel={false}
              disabled
              name="Number of columns"
              label={'Number of columns'}
              // value={parseInt(roomChoosen[0]?.numberOfColumn)}
              value={selectedFacilityData?.noOfColumns}
              // onChange={(e) =>
              //   SetIntercandidateSpacing(parseInt(e.target.value))
              // }
              style={{ fontSize: 12 }}
              type="Number"
            />
          </Grid>
          <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
            <KenInputField
              optionalLabel={false}
              label={'No of invigilators required'}
              name="No of invigilators"
              value={selectedFacilityData?.noOfInvigilators == null ? 0 : selectedFacilityData?.noOfInvigilators}
              onChange={(e) => {
                if (
                  e.target.value.length > 1 &&
                  e.target.value.match(/^[1-9]+$/)
                ) {
                  enqueueSnackbar('Please use a single digit number', {
                    variant: 'warning',
                  });
                } else {
                  const roomChoosenData = [...roomChoosen];
                  const selectData = { ...selectedFacilityData }
                  const index = roomChoosenData.findIndex(
                    (el) => el?.facilityId === selectedFacilityData?.facilityId
                  );
                  roomChoosenData[index].noOfInvigilators = e.target.value;
                  selectData.noOfInvigilators = e.target.value;
                  setSelectedFaciltyData(selectData)
                  setRoomChoosen(roomChoosenData);
                }
              }}
              style={{ fontSize: 12 }}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default SeatingplanInput;
